import { useState } from "react";
import { List, Phone, EnvelopeSimple } from "@phosphor-icons/react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";

const LOGO = "https://assets.weimobtrade.com/20260212/997eb3f7e375ce03c7d534ac53fea4f7.png/source";

const LINKS = [
  { href: "#top", label: "Home", id: "nav-home-link" },
  { href: "#machines", label: "Products", id: "nav-machines-link" },
  { href: "#solutions", label: "Industries", id: "nav-solutions-link" },
  { href: "#cases", label: "Case Studies", id: "nav-cases-link" },
  { href: "#about", label: "About Us", id: "nav-about-link" },
  { href: "https://www.youtube.com/@fiberlasercuttingmachine", label: "Videos", id: "nav-videos-link", external: true },
  { href: "#contact", label: "Contact", id: "nav-contact-link" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header data-testid="site-navbar" className="fixed top-0 left-0 right-0 z-50">
      <div className="bg-navy">
        <div className="mx-auto flex h-9 max-w-7xl items-center justify-between px-4 sm:px-8">
          <span className="hidden text-xs text-white/80 sm:block">Industrial Laser System Manufacturer - Australia</span>
          <div className="flex items-center gap-5">
            <a href="tel:+61404040920" data-testid="topbar-phone" className="flex items-center gap-1.5 text-xs text-white/80 transition-colors hover:text-white">
              <Phone size={13} weight="bold" /> +61 404 040 920
            </a>
            <a href="mailto:sales@pentalaser.com.au" data-testid="topbar-email" className="hidden items-center gap-1.5 text-xs text-white/80 transition-colors hover:text-white sm:flex">
              <EnvelopeSimple size={13} weight="bold" /> sales@pentalaser.com.au
            </a>
          </div>
        </div>
      </div>
      <div className="border-b border-border bg-white/95 shadow-sm backdrop-blur">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-8">
          <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5">
            <img src={LOGO} alt="Penta Laser logo" className="h-9 w-9 object-contain" />
            <span className="text-xl font-bold uppercase tracking-tight text-navy">
              Penta Laser
              <span className="ml-2 align-middle text-[10px] font-semibold tracking-[0.2em] text-laser">AUSTRALIA</span>
            </span>
          </a>
          <nav className="hidden items-center gap-7 lg:flex">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={l.id}
                {...(l.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                className="text-[13px] font-semibold uppercase tracking-wide text-[#333] transition-colors duration-150 hover:text-laser"
              >
                {l.label}
              </a>
            ))}
            <a href="#contact" data-testid="nav-quote-btn" className="bg-laser px-5 py-2.5 text-[13px] font-semibold uppercase tracking-wide text-white transition-colors duration-150 hover:bg-laser-hover">
              Get a Quote
            </a>
          </nav>
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button data-testid="nav-mobile-menu-btn" className="p-2 text-navy lg:hidden" aria-label="Open menu">
                <List size={26} weight="bold" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="w-72 border-l border-border bg-white">
              <nav className="mt-10 flex flex-col gap-5">
                {LINKS.map((l) => (
                  <a
                    key={l.href}
                    href={l.href}
                    data-testid={`${l.id}-mobile`}
                    onClick={() => setOpen(false)}
                    {...(l.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    className="text-sm font-semibold uppercase tracking-wide text-[#333] hover:text-laser"
                  >
                    {l.label}
                  </a>
                ))}
                <a href="#contact" data-testid="nav-quote-btn-mobile" onClick={() => setOpen(false)} className="mt-4 bg-laser px-5 py-3 text-center text-xs font-semibold uppercase tracking-wide text-white">
                  Get a Quote
                </a>
                <a href="tel:+61404040920" data-testid="nav-phone-mobile" className="mt-2 flex items-center gap-2 text-sm text-muted-foreground">
                  <Phone size={18} weight="bold" /> +61 404 040 920
                </a>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
